import { color } from 'styles/colors'
import { focusOutline } from 'styles/shared'

export const menuItem = ({ executable = false, sectionSplit = false, showFocusOutline = false } = {}) => (
  `
    display: block;
    padding: 10px 15px;
    color: ${color('tooltipText')};
    border-bottom: 1px solid ${color('menuItemSplit')};

    &:first-child {
      margin-top: -8px;
    }

    &:last-child {
      margin-bottom: -8px;
      border-bottom: none;
    }

    ${showFocusOutline && focusOutline()}

    ${executable && `
      cursor: pointer;
      font-weight: bold;
      width: 100%;
      text-align: left;

      &:hover {
        background-color: ${color('secondaryButtonHover')};
        color: ${color('primaryText')};
      }

      &:focus {
        color: ${color('primaryText')};
      }
    `}

    ${sectionSplit && `
      border-top: 1px solid ${color('menuItemSectionSplit')};
    `}
  `
)
